import { createFileRoute } from '@tanstack/react-router';

import { ApiDocsPage } from '@/features/api-docs/components/api-docs-page';
import { requireOrganizationRoute } from '@/lib/router-guards';

export const Route = createFileRoute('/_app/api-docs')({
    beforeLoad: requireOrganizationRoute,
    component: ApiDocsPage
});
